/*
 * File: ObfuscatedText.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:53 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: April 18, 2025 at 10:37 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';


/**
 * Styles
 */

export const Obfuscate = styled.span`
	display: unset;
	color: ${({ theme }) => theme.obfuscationGreyText};
	background-color: ${({ theme }) => theme.obfuscationGrey};
	border-radius: 2px;
	-webkit-box-decoration-break: clone;
	-o-box-decoration-break: clone;
	box-decoration-break: clone;
	padding: 1px 4px;
`;
